import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SubscribableOrPromise } from 'rxjs/Observable';

export class RetryInterval {
    constructor(
        protected interval: number = 0,
        protected exponentialFactor: number = 1,
        protected polynomialFactor: number = 0
    ) { }

    get(retryNumber: number): Observable<number> {
        let exponentialFactor = Math.pow(this.exponentialFactor, retryNumber);
        let polynomialFactor = Math.pow(retryNumber, this.polynomialFactor);
        let interval = this.interval * exponentialFactor * polynomialFactor;
        console.log(`Retrying Observable after ${interval}ms`);
        return Observable.timer(interval).map(() => retryNumber);
    }
}

@Injectable()
export class ObservableUtils {
    retry<V>(
        retryable: () => SubscribableOrPromise<V>,
        maxRetries: number = Number.MAX_SAFE_INTEGER - 1,
        interval: RetryInterval = new RetryInterval(),
        errorPredicate: (error: any) => boolean = () => true
    ) {
        return Observable.defer(retryable)
            .retryWhen(attempts => attempts.zip(Observable.range(0, maxRetries + 1)).switchMap(([error, retryNumber]) => {
                if (retryNumber >= maxRetries) {
                    console.warn(`Observable exceeded ${maxRetries} retries`);
                    return Observable.throw(error);
                }
                if (!errorPredicate(error)) {
                    return Observable.throw(error);
                }
                console.log('Retrying observable due to error', error);
                return interval.get(retryNumber);
            }));
    }
}



// WEBPACK FOOTER //
// ./src/app/util/observable-utils.ts